import axios from "../axiosInstance"
import { formatarDataRequisicao } from "../shared/utils/Formatacao"
import { exportarRelatorioUtilizacao, listarLaboratorios } from "../shared/utils/Endpoints"
import qs from "qs"
import { converterArquivoStreamParaBlob } from "../shared/utils/ArquivoUtil";

class LaboratorioService {
    async baixarRelatorioUtilizacao(periodo) {
        return await axios.get(exportarRelatorioUtilizacao, {
            params: {
                DataInicio: periodo && formatarDataRequisicao(periodo.dataInicio),
                DataFim: periodo && formatarDataRequisicao(periodo.dataFim),
            },
            paramsSerializer: (params) => {
                return qs.stringify(params)
            },
            responseType: "arraybuffer"
        }).then((res) => {
            if (res?.data) {
                return converterArquivoStreamParaBlob(res.data);
            }
        });
    }

    async listarLaboratorios(termo) {
        return await axios.get(listarLaboratorios, {
            params: {
                Termo: termo
            },
        })
    }
}

export default new LaboratorioService()